export default __webpack_public_path__ + "static/oncojs-7cede6309a99f9d89477185e2fd229c0.svg";